import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Breadcrumb } from 'antd';

class MyBreadcrumb extends Component {
	render() {
		const itemsEle = this.props.urls ? this.props.urls.map((item, index) =>
			index === this.props.urls.length - 1 ? (
				<Breadcrumb.Item key={item.breadcrumbName}>
					{item.breadcrumbName}
				</Breadcrumb.Item>)
				: (<Breadcrumb.Item key={item.url}>
					<Link to={item.url}>{item.breadcrumbName}</Link>
				</Breadcrumb.Item>
				)
		):(<></>)


		const breadcrumbItems = [
			<Breadcrumb.Item key="index">
			  <Link to="/index">首页</Link>
			</Breadcrumb.Item>
		  ].concat(itemsEle);

		return (
			<Breadcrumb style={{marginBottom: 20}} separator=">">
				{breadcrumbItems}
			</Breadcrumb>
		);
	}
}

export default withRouter(MyBreadcrumb)
